import React, { useState, useEffect } from "react";
import {
  Tabs, Tab, Form, Button, Table, Col, Row, Card, Alert, Badge, Modal,
  ProgressBar, Accordion, InputGroup, Toast, ToastContainer, Spinner
} from "react-bootstrap";
import {
  FaShieldAlt, FaFileDownload, FaPlus, FaEdit, FaTrash, FaCheck, FaTimes,
  FaExclamationTriangle, FaGlobe, FaLock, FaUserShield,
  FaKey
} from "react-icons/fa";
import NavigationBar from "../Nav";
import { FaClock } from "react-icons/fa";  // Add to existing react-icons imports
import CrossBorderTransfersTab from "./GdprCrossBorderTransfersTab";
import PolicyGeneratorTab from "./GdprPolicyGeneratorTab";
import DsarManagementTab from "./GdprDsarManagementTab";
import GDPRInventoryTab from "./GDPRInventoryTab";
import GDPRRetentionTab from "./GDPRRetentionTab";
import SecurityEncryptionTab from "./GDPRSecurityEncryptionTab";
import Menubar from "../Menubar";
import BackgroundFooter from "../BackgroundFooter";
import "../../ComponentsCss/CCPA.css"

const GDPRModule = ({ userData }) => {
  const [activeKey, setActiveKey] = useState("dashboard");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [recentActivities, setRecentActivities] = useState([]);
  const [complianceMetrics, setComplianceMetrics] = useState({});
  // Add subscription states
const [subscriptionStatus, setSubscriptionStatus] = useState(null);
const [subscriptionLoading, setSubscriptionLoading] = useState(true);
const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
const [trialEndDate, setTrialEndDate] = useState(null);
const [isExpired, setIsExpired] = useState(false);
const [checkingOutPayment, setCheckingOutPayment] = useState(false);
const [secondTrialUsed, setSecondTrialUsed] = useState(false);
const [subscriptionKey, setSubscriptionKey] = useState('');
const [isActivatingKey, setIsActivatingKey] = useState(false);
const [keyValidationError, setKeyValidationError] = useState('');




  // Detect user region for GDPR jurisdiction
  const getUserRegion = () => sessionStorage.getItem("userRegion") || "GB";

  // Load activity history
const fetchRecentActivities = async () => {
  const userId = userData?.["cognito:username"] 
  const region = getUserRegion();
  
  try {
    const res = await fetch(`https://8j1rni4in1.execute-api.ap-southeast-2.amazonaws.com/prod/api/activity-log/list?t=${Date.now()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Region": region,
        "UserId": userId
      }
    });
    const data = await res.json();
    setRecentActivities(data);
    console.log('✅ Recent activities refreshed:', data.length);
  } catch (err) {
    console.error("Error fetching recent activities", err);
  }
};

// Call it on mount
useEffect(() => {
  fetchRecentActivities();
}, [userData]);


  // Sidebar toggle and persist
  const handleSidebarToggle = () => setIsSidebarCollapsed((prev) => !prev);
  useEffect(() => {
    localStorage.setItem("gdprIsSidebarCollapsed", JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  // Notification helper
  const showNotification = (message, variant = "success") => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true);
  };
// Subscription action handlers
const handleStartTrial = async () => {
  try {
    const res = await fetch('https://7b3mrfutle.execute-api.ap-southeast-2.amazonaws.com/prod/api/billing/start-trial', {
      method: 'POST',
      headers: {
        'UserId': userData["cognito:username"],
        'Region': sessionStorage.getItem('userRegion') || 'IN'
      }
    });
    
    if (res.ok) {
      window.location.reload();
    } else {
      alert('Failed to start trial');
    }
  } catch (err) {
    alert('Failed to start trial');
  }
};
const handleStartSecondTrial = async () => {
  try {
    const res = await fetch('https://80gbnjdo0k.execute-api.ap-southeast-2.amazonaws.com/prod/api/billing/start-second-trial', {
      method: 'POST',
      headers: {
        'UserId': userData["cognito:username"],
        'Region': sessionStorage.getItem('userRegion') || 'IN'
      }
    });
    
    if (res.ok) {
      window.location.reload();
    } else {
      alert('Second trial not available or already used');
    }
  } catch (err) {
    alert('Failed to start second trial');
  }
};

const handleActivateSubscriptionKey = async () => {
  if (!subscriptionKey.trim()) {
    setKeyValidationError('Please enter a subscription key');
    return;
  }

  setIsActivatingKey(true);
  setKeyValidationError('');
  
  try {
    const region = sessionStorage.getItem("userRegion") || "GB";
   const response = await fetch("https://l7rleysajb.execute-api.ap-southeast-2.amazonaws.com/prod/api/subscription/activate-key", { // ✅ CORRECT ENDPOINT

      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'UserId': userData["cognito:username"],
        'Region': region
      },
      body: JSON.stringify({ subscriptionKey: subscriptionKey.trim() })
    });

    const data = await response.json();
    
    if (response.ok) {
      showNotification('🎉 Subscription activated! Premium GDPR features unlocked.', 'success');
      setShowSubscriptionModal(false);
      setSubscriptionKey('');
      window.location.reload();
    } else {
      setKeyValidationError(data.error || 'Invalid subscription key. Please check and try again.');
    }
  } catch (err) {
    console.error("Key activation failed", err);
    setKeyValidationError("Failed to activate subscription key. Please try again.");
  } finally {
    setIsActivatingKey(false);
  }
};

const handleSubscriptionKeyEntry = () => {
  // Just show the modal - the key entry UI is already there
};




// const handleManageBilling = async () => {
//   try {
//     const response = await fetch('https://0shbfl9j5a.execute-api.eu-west-1.amazonaws.com/prod/api/billing/portal-session', {
//       method: 'POST',
//       headers: {
//         'UserId': userData["cognito:username"],
//         'Region': sessionStorage.getItem('userRegion') || 'IN'
//       }
//     });
    
//     const data = await response.json();
//     if (data.url) {
//       window.open(data.url, '_blank');
//     }
//   } catch (err) {
//     alert('Could not open billing portal');
//   }
// };

// Subscription banner rendering
const renderSubscriptionBanner = () => {
  if (subscriptionStatus === 'trialing' && trialEndDate) {
    const daysLeft = Math.floor((new Date(trialEndDate) - new Date()) / (1000 * 60 * 60 * 24));
    const isUrgent = daysLeft <= 3;
    const trialType = secondTrialUsed ? "Second Trial" : "Free Trial";
    
    return (
      <Alert variant={isUrgent ? "danger" : "warning"} className="mb-4 trialWarning">
        <div className="d-flex justify-content-between align-items-center gap-2">
          <div>
            <FaClock className="me-2" />
            <strong>{trialType} Active:</strong> {daysLeft} days remaining
            {isUrgent && <span className="text-danger ms-2">(Urgent: Trial ending soon!)</span>}
          </div>
          <Button variant={isUrgent ? "btn btn-danger" : "btn btn-success"} size="sm" onClick={() => setShowSubscriptionModal(true)}>
  Enter Key / Extend
</Button>

        </div>
      </Alert>
    );
  }
  
  if (subscriptionStatus === 'active') {
    return (
      <Alert variant="success" className="mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <FaCheck className="me-2" />
            <strong>Subscription Active:</strong> Premium features enabled
          </div>
          <Button   className="ms-2" variant="outline-success" size="sm" onClick={() => setShowSubscriptionModal(true)}>
  Manage Subscription
</Button>

        </div>
      </Alert>
    );
  }
  
  return null;
};


  // Compliance metrics calculation (aggregate modular scores)
  useEffect(() => {
    console.log("📊 Recalculating overallScore from complianceMetrics:", complianceMetrics);
    const values = Object.entries(complianceMetrics)
      .filter(([key]) => key !== 'overallScore')
      .map(([_, val]) => val);
    const average = values.reduce((sum, val) => sum + val, 0) / values.length || 0;
    setComplianceMetrics((prev) => ({
      ...prev,
      overallScore: Math.round(average),
    }));
  }, [
    complianceMetrics.crossBorderTransfers,
    complianceMetrics.dsarManagement,
    complianceMetrics.dataMapping,
    complianceMetrics.retentionPolicies,
    complianceMetrics.securityMeasures,
  ]);
// Add subscription checking useEffect
// useEffect(() => {
//   const checkOrgSubscription = async () => {
//     if (!userData?.["cognito:username"]) return;
    
//     try {
//       setSubscriptionLoading(true);
//       const res = await fetch('https://atw24p2ef8.execute-api.ap-southeast-2.amazonaws.com/prod/api/org/subscription-status', {
//         method: 'GET',
//         headers: {
//           'UserId': userData["cognito:username"],
//           'Region': sessionStorage.getItem('userRegion') || 'IN'
//         }
//       });
      
      
//      const data = await res.json();
//      setSubscriptionStatus(data.status);
//      setTrialEndDate(data.trialEnd);
//      setSecondTrialUsed(data.secondTrialUsed || false); // ✅ ADD THIS LINE

      
//       // Show modal if subscription needed
//       if (['canceled', null].includes(data.status)) {
//   setIsExpired(data.status === 'canceled'); // Only expired if canceled
//   setShowSubscriptionModal(true);
// }

      
//     } catch (err) {
//       console.error('Failed to fetch subscription status:', err);
//     } finally {
//       setSubscriptionLoading(false);
//     }
//   };
  
//   checkOrgSubscription();
// }, [userData]);
// Subscription disabled for GDPR module
useEffect(() => {
  setSubscriptionStatus("active");
  setSubscriptionLoading(false);
}, []);

  // Prevent right-click (anti-scraping etc.)
  const disableRightClick = (e) => {
    e.preventDefault();
  };

  // if (subscriptionLoading) {
  //   return (
  //     <div className="d-flex justify-content-center align-items-center" style={{height: '60vh'}}>
  //       <Spinner animation="border" variant="primary" />
  //       <span className="ms-3">Checking subscription...</span>
  //     </div>
  //   );
  // }

  return (
    <div onContextMenu={disableRightClick}>
    
        <Row className="g-0">
  <Col
    xs={12}
    className={`bg-transparent sidebar-container ${isSidebarCollapsed ? "collapsed" : "hello"}`}
    style={{
      width: isSidebarCollapsed ? "90px" : "317px",
      transition: "width 0.3s ease",
    }}
  >
    <Menubar
      isCollapsed={isSidebarCollapsed}
      onToggle={handleSidebarToggle}
      
    />
  </Col>



  <Col
    className="pt-0 px-0  ps-0 section-container"
    style={{
      width: `calc(100% - ${isSidebarCollapsed ? "90px" : "317px"})`,
      transition: "width 0.3s ease",
    }}
  >
    <NavigationBar
      userData={userData}
      isSidebarCollapsed={isSidebarCollapsed}
    />

   
    <Col className="overflow-auto p-4">
     {/* {renderSubscriptionBanner()} */}
          
          <div className={showSubscriptionModal ? 'blur-content' : ''}>
          <Tabs
            id="gdpr-module-tabs"
            activeKey={activeKey}
            onSelect={setActiveKey}
            className="mb-3"
          >
            <Tab tabClassName="dashboard2" eventKey="dashboard" title="📊 Dashboard" >
              <Card>
                <Card.Body>
                  <Card.Title>GDPR Compliance Dashboard</Card.Title>
                  <Row>
                    <Col md={4}>
                      <h5>Compliance Overview</h5>
                      <ProgressBar className="ProgressBar"
                        label={`Overall: ${complianceMetrics.overallScore || 0}%`}
                        now={complianceMetrics.overallScore || 0}
                        variant="success"
                      />
                    </Col>
                    <Col md={8}>
                      <h5>Recent Activities</h5>
                      <Table hover size="sm">
                        <thead>
  <tr>
    <th>Date</th>
    <th>Module</th>
    <th>Details</th>
    <th>Action</th>
  </tr>
</thead>

                        <tbody>
                          {recentActivities.length === 0 ?
                            <tr><td  className="td3" colSpan={4}>No recent activities found.</td></tr> :
                           recentActivities.map((act, i) => (
  <tr key={i}>
    <td>{act.timestamp ? new Date(act.timestamp).toLocaleString() : ""}</td>
    <td>
      <Badge bg="secondary" className="me-1">
        {act.module || "General"}
      </Badge>
    </td>
    <td>{act.details || "No details available"}</td>
    <td>
      <Badge bg={
        act.action === 'success' ? 'success' : 
        act.action === 'error' ? 'danger' : 
        act.action === 'warning' ? 'warning' : 'info'
      }>
        {act.action || "info"}
      </Badge>
    </td>
  </tr>
))

                          }
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Tab>
            <Tab tabClassName="dashboard2" eventKey="inventory" title="📋 Inventory">
              <GDPRInventoryTab
                userData={userData}
                onScoreUpdate={(score) => setComplianceMetrics((prev) => ({ ...prev, dataMapping: score }))}
                showNotification={showNotification}
                region={getUserRegion()}
                 refreshActivities={fetchRecentActivities} 
              />
            </Tab>
            <Tab tabClassName="dashboard2" eventKey="retention" title="⏰ Retention">
              <GDPRRetentionTab
                userData={userData}
                onScoreUpdate={(score) => setComplianceMetrics((prev) => ({ ...prev, retentionPolicies: score }))}
                showNotification={showNotification}
                region={getUserRegion()}
                refreshActivities={fetchRecentActivities} 
              />
            </Tab>
            <Tab tabClassName="dashboard2" eventKey="dsar" title="🔍 DSAR Management">
              <DsarManagementTab
                userData={userData}
                onScoreUpdate={(score) => setComplianceMetrics((prev) => ({ ...prev, dsarManagement: score }))}
                showNotification={showNotification}
                region={getUserRegion()}
                refreshActivities={fetchRecentActivities} 
              />
            </Tab>
            <Tab tabClassName="dashboard2" eventKey="crossborder" title="🔄️ Transfers">
              <CrossBorderTransfersTab
                userData={userData}
                onScoreUpdate={(score) => setComplianceMetrics((prev) => ({ ...prev, crossBorderTransfers: score }))}
                showNotification={showNotification}
                region={getUserRegion()}
                refreshActivities={fetchRecentActivities} 
              />
            </Tab>
            <Tab tabClassName="dashboard2" eventKey="policygen" title="📝 Policy Generator">
              <PolicyGeneratorTab
                userData={userData}
                showNotification={showNotification}
                region={getUserRegion()}
                refreshActivities={fetchRecentActivities} 
              />
            </Tab>
            <Tab tabClassName="dashboard2" eventKey="security" title="🔐 Security/Encryption">
              <SecurityEncryptionTab
                userData={userData}
                onScoreUpdate={(score) => setComplianceMetrics((prev) => ({ ...prev, securityMeasures: score }))}
                showNotification={showNotification}
                region={getUserRegion()}
                refreshActivities={fetchRecentActivities} 
              />
            </Tab>
          </Tabs>
          </div>
          


           </Col>
             <BackgroundFooter isSidebarCollapsed={isSidebarCollapsed}  />
        </Col>
      </Row>
     
      <ToastContainer position="bottom-end" className="p-3">
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          bg={toastVariant}
          autohide
          delay={2500}
        >
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default GDPRModule;
